module.exports = __webpack_public_path__ + "static/img/face08.cd00952.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/face08.jpg
// module id = xX53
// module chunks = 0